import { render, staticRenderFns } from "./SessionBlock.vue?vue&type=template&id=65433082&scoped=true&"
import script from "./SessionBlock.vue?vue&type=script&lang=js&"
export * from "./SessionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65433082",
  null
  
)

export default component.exports